import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import SearchBar from '../Components/SearchBar'
import { Form, FormControl } from 'react-bootstrap';
import env from '../ENV';
import AuthHandlerInstance from '../Classes/AuthHandler';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { GetAllPoAcceptanceDetailForSupplier } from '../store/actions/vendorActions';
import { connect } from 'react-redux'
import Modal from '../Components/CustomModal'
import ModalHeader from '../Components/ModalHeader'
import ModalBody from '../Components/ModalBody'
import ModalFooter from '../Components/ModalFooter'
import SuccessFailureModal from '../Components/Success_Failure_Modal_forDispatch';
import swal from '@sweetalert/with-react';
import { uploadPaymentAcknowledgement } from '../store/actions/fileActions';
import { postDeliveryScheduleDetails, updateDeliveryScheduleDetails } from '../store/actions/expediting.Actions';
import POCommentPopUp from '../Components/POCommentPopUp';
import { postCommentsForPOs } from '../store/actions/expediting.Actions'
import numberWithCommas from '../Classes/NumberwithComma'
import dateFormater from '../Classes/FormatDate'

const FILESERVER_ROOT_URL = env.FILE_SERVER_URL;

class ExpeditingApprovedDeliverySchedule extends React.Component {

  constructor(props) {
    super(props);
    this.state = {

      reviseForm: { file: [] },
      allChecked: false,
      supplierName: "ABC Tech Inc.",
      select: true,
      selectAll: false,
      selected: [],
      checkbox: false,
      open: false,
      searchTerm: null,
      checked: [],
      searchInput: "",
      checkedArray: [],
      opacity: "",
      comments: '',
      formattedData: [],
      selectAll: false,
      DeliverScheduleModal: false,
      ApproveScheduleModal: false,
      ReviseScheduleModal: false,
      modal: false,
      lorryreceiptmodal: false,
      multiCollapseIndex: "",
      ExpectedDeliveryDate: "",
      SubmissionDueDate: "",
      POCommentPopUpModal: false,
      POId: "",
      PoLineItemId: ""
    }

    this.comments = this.comments.bind(this);
    this.togglebutton = this.togglebutton.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleSingleCheckboxChange = this.handleSingleCheckboxChange.bind(this);
    this.deliverschedulemodal = this.deliverschedulemodal.bind(this);
    this.approveschedulemodal = this.approveschedulemodal.bind(this);
    this.reviseschedulemodal = this.reviseschedulemodal.bind(this);
    this.modal = this.modal.bind(this);
    this.modalSubmit = this.modalSubmit.bind(this);
    this.approvalmodalsubmit = this.approvalmodalsubmit.bind(this);
    this.revisemodalsubmit = this.revisemodalsubmit.bind(this);
    this.POCommentPopUpModal = this.POCommentPopUpModal.bind(this);

  }





  action1() {
    this.setState({ action1: false });
  }

  togglebutton = (Index) => {

    var multiCollapseIndex = this.state.multiCollapseIndex

    if (multiCollapseIndex != Index || multiCollapseIndex == '') {
      this.setState({ multiCollapseIndex: Index })
    }
  }

  handleChange = () => {
    var roles = AuthHandlerInstance.getRoles()
    var selectAll = !this.state.selectAll;
    let selected = this.state.selected;
    let select = !this.state.select;
    this.setState({ selectAll });
    var checkedCopy = [];
    this.props.allpodetailsuplier.allpodetails.recordset.map(function (e, index) {
      let data = { po: e.PurchaseOrderId, polineid: e.PurchaseOrderLineId }
      if (roles[12]) {
        if (e.ExpeditingStatusId == 1) {
          checkedCopy.push(data);
        }
        
      } else if (roles[5]) {
        if(e.ExpeditingStatusId==0 || e.ExpeditingStatusId==3) {
          checkedCopy.push(data);
        }
      }
      else {
        checkedCopy.push(data);
      }
      
    });
    if (selectAll) {
      this.setState({
        checked: checkedCopy, checkedArray: checkedCopy
      });
    } else {
      this.setState({
        checked: [], checkedArray: []
      });
    }
    console.log(checkedCopy , 'checkedCopy')
  }

  handleSingleCheckboxChange = index => {
    var checkedArray = this.state.checkedArray
    let selected = this.state.selected;
    let status = index in selected ? !selected[index] : true
    selected[index] = status
    if (selected[index] == true) {
      let data = {
        po: this.props.allpodetailsuplier.allpodetails.recordset[index].PurchaseOrderId,
        polineid: this.props.allpodetailsuplier.allpodetails.recordset[index].PurchaseOrderLineId
      }
      checkedArray.push(data)
      console.log(data, ' ####')
    } else {
      var index = checkedArray.indexOf(index);
      if (index !== -1) {
        checkedArray.splice(index, 1);
      }
    }
    this.setState({ selected, checkedArray });
  };

  toggleSuccessModal(e) {
    this.setState({ modal: !this.state.modal });
    if (this.state.modal == true) {
      this.setState(
        { opacity: "" }
      )
    }
    else {
      this.setState(
        { opacity: "0.2" }
      )
    }
  }

  comments(event) {
    this.setState({ comments: event.target.value })
    console.log(this.state.comments,"KKKKK")
  }

  handleFileInput = (event) => {
    let reviseForm = this.state.reviseForm

    reviseForm.file.push(event.target.files[0])
    this.setState({ reviseForm });
    // console.log(this.state.reviseForm, 'file dekh')
  }

  modalSubmit = async () => {
    var roles = AuthHandlerInstance.getRoles()
    var user = AuthHandlerInstance.getUserID()
    if (this.state.reviseForm.file.length < 1) {
      swal("Please upload some valid document", { icon: "error" })

      return false;
    }
    swal("Document is uploading...", { button: false, icon: "info" })
    var result = await this.props.uploadPaymentAcknowledgement(this.state.reviseForm.file)

    var params = {}
    var inputComments = {}
    if (result.results[0].VersionId && result.results[0].DocumentId) {
      this.state.checkedArray.map(async (item) => {
        console.log(item)
        params = {
          POId: item.po,
          PoLineItemId: item.polineid,
          Documentid: result.results[0].DocumentId,
          versionId: result.results[0].VersionId,
        }
        console.log(params)
        inputComments = {
          Comments: this.state.comments,
          POId: item.po,
          PoLineItemId: item.polineid,
          UserId: user,
        }
        console.log(inputComments,"|||||||||||||||||||||")
        await this.props.postDeliveryScheduleDetails(params)
        if(this.state.comments != "")
        {
          await this.props.postCommentsForPOs({
            Comments: this.state.comments,
            POId: item.po,
            PoLineItemId: item.polineid,
            UserId: user,
          })
        }
      })
    }
    else
      {
        swal("Please Upload Delivery Schedule before submit", { icon: "error" })
      }
    await this.setState({ comments: '', checkedArray: [] })
    await this.deliverschedulemodal()
    await this.dataSync()
    // window.location.reload()
  }


  handleClick = () => {
    var datePattern = document.getElementById('myDate').value;
    document.getElementById("demo").innerHTML = datePattern;
    console.log(datePattern, " !!!!!")
  }
  onclickDownload = async (documentID) => {

    var url = FILESERVER_ROOT_URL + "files/Documents/" + documentID + "/download"
    window.location.href = url

  }
  modal() {
    this.setState({ modal: !this.state.modal });
    if (this.state.DeliverScheduleModal == true) {
      this.setState({ DeliverScheduleModal: !this.state.DeliverScheduleModal });
    }
    if (this.state.ApproveScheduleModal == true) {
      this.setState({ ApproveScheduleModal: !this.state.ApproveScheduleModal });
    }
    if (this.state.ReviseScheduleModal == true) {
      this.setState({ ReviseScheduleModal: !this.state.ReviseScheduleModal });
    }
    if (this.state.modal == true) {
      this.setState({ opacity: "" })
    }
    else {
      this.setState({ opacity: "0.2" })
    }
  }

  deliverschedulemodal() {
    console.log(this.state.checkedArray)
    this.setState({ DeliverScheduleModal: !this.state.DeliverScheduleModal });
    this.setState({ text: "The delivery Schedule document for PO Item No.:10,11 for PO No. :4700026943 has been submitted successfully. " });
    this.setState({ headertitle: "Delivery Schedule Uploaded Successfully" });
    if (this.state.DeliverScheduleModal == true) {
      this.setState(
        { opacity: "" }
      )
    }
    else {
      this.setState(
        { opacity: "0.2" }
      )
    }
  }

  approveschedulemodal() {
    this.setState({ ApproveScheduleModal: !this.state.ApproveScheduleModal });

    this.setState({ text: "The delivery Schedule document for PO Item No.:10,11 for PO No. :4700026943 has been approved " });
    this.setState({ headertitle: "Delivery Schedule Approved Successfully" });
    if (this.state.ApproveScheduleModal == true) {
      this.setState(
        { opacity: "" }
      )
    }
    else {
      this.setState(
        { opacity: "0.2" }
      )
    }
  }

  reviseschedulemodal() {
    this.setState({ ReviseScheduleModal: !this.state.ReviseScheduleModal });
    this.setState({ text: "The delivery Schedule document for PO Item No.:10,11 for PO No. :4700026943 has been sent for revision " });
    this.setState({ headertitle: "Delivery Schedule sent for Revision" });
    if (this.state.ApproveScheduleModal == true) {
      this.setState(
        { opacity: "" }
      )
    }
    else {
      this.setState(
        { opacity: "0.2" }
      )
    }
  }

  handleExpectedDeliveryDate(e) {
    console.log(e.target.value)
    this.setState({ ExpectedDeliveryDate: e.target.value })
  }

  handleSubmissionDueDate(e) {
    console.log(e.target.value)
    this.setState({ SubmissionDueDate: e.target.value })
  }

  approvalmodalsubmit= async() =>{

    var roles = Object.keys(AuthHandlerInstance.getRoles())[0]

    this.state.checkedArray.map(async (element) => {
      var params = {
        POId: element.po,
        POLineItemId: element.polineid,
        IsApproved: 1,
        ExpectedDeliveryDate: this.state.ExpectedDeliveryDate?this.state.ExpectedDeliveryDate:null,
        DocumentSubmissionDueDate: this.state.SubmissionDueDate?this.state.SubmissionDueDate:null,
        roleId: roles
      }
      // console.log(params)
      await this.props.updateDeliveryScheduleDetails(params)
      
    })


    if(roles==7){
      this.approveschedulemodal()
    }

    await this.dataSync()
    // window.location.reload()

  }

  // revisemodalsubmit = async () => {
  //   var params = {}
  //   var inputComments = {}

    
  //   this.state.checkedArray.map(async (element) => {
  //     params = {
  //       POId: element.po,
  //       POLineItemId: element.polineid,
  //       IsApproved: 0,
  //       ExpectedDeliveryDate: null,
  //       DocumentSubmissionDueDate: null,
  //       roleId: 0
  //     }
  //     inputComments = {
  //       POId: element.po,
  //       PoLineItemId: element.polineid,
  //       UserId: AuthHandlerInstance.getUserID(),
  //       Comments: this.state.comments
  //     }
  //     console.log(params, inputComments, "Validation")
  //     await this.props.updateDeliveryScheduleDetails(params)
  //     if(inputComments.Comments != " ")
  //     {
  //       await this.props.postCommentsForPOs({
  //         POId: element.po,
  //         PoLineItemId: element.polineid,
  //         UserId: AuthHandlerInstance.getUserID(),
  //         Comments: this.state.comments
  //       })
  //     }
  //     // this.modal()
  //   })
  //   await this.setState({ comments: '', checkedArray: [], ReviseScheduleModal: false })
  //   await this.dataSync()
  //   // window.location.reload()
  // }

  handleISearch = (e) => {
    let searchTerm = e.target.value
    this.setState({ searchTerm })
  }

  handleSearching = async () => {
    console.log(this.state.searchTerm, typeof (this.state.searchTerm), "************************")

    var roles = Object.keys(AuthHandlerInstance.getRoles())[0]
    var user = AuthHandlerInstance.getUserID()
    if (roles == 5)
      this.props.GetAllPoAcceptanceDetailForSupplier(user, this.state.searchTerm)
    if (roles == 12 )
      this.props.GetAllPoAcceptanceDetailForSupplier(0, this.state.searchTerm)
    if (roles == 7)
      this.props.GetAllPoAcceptanceDetailForSupplier(0, this.state.searchTerm, 1)
    console.log("Search complete, results are : ", this.props.allpodetailsuplier.allpodetails)
    // await this.setState({ searchInput: "" })

  }

  dataSync=async()=>{
    var roles = Object.keys(AuthHandlerInstance.getRoles())[0]
    console.log(roles, "***************")
    var user = AuthHandlerInstance.getUserID()
    if (roles == 5)
      await this.props.GetAllPoAcceptanceDetailForSupplier(user, this.state.searchTerm)
    if (roles == 12 || roles == 6 )
      await this.props.GetAllPoAcceptanceDetailForSupplier(0, this.state.searchTerm, 0)
    if (roles == 7)
      await this.props.GetAllPoAcceptanceDetailForSupplier(0, this.state.searchTerm, 1)
  }


  componentDidMount() {
    
this.dataSync()

  }

  POCommentPopUpModal() {
    this.setState({ POCommentPopUpModal: !this.state.POCommentPopUpModal });
    this.setState({ RetentionDocumentsModal: false });
    if (this.state.POCommentPopUpModal == true) {
      this.setState(
        { opacity: "" }
      )
    }
    else {
      this.setState(
        { opacity: "0.2" }
      )
    }
  }

  togglePOCommentPopUpModal(e) {
    this.setState({ POCommentPopUpModal: !this.state.POCommentPopUpModal });
    if (this.state.POCommentPopUpModal == true) {
      this.setState(
        { opacity: "" }
      )
    }
    else {
      this.setState(
        { opacity: "0.2" }
      )
    }
  }
  rowClick(index) {
    let poId = this.props.allpodetailsuplier.allpodetails.recordset[index].PurchaseOrderId
    let poLineId = this.props.allpodetailsuplier.allpodetails.recordset[index].PurchaseOrderLineId
    console.log(poId, poLineId, "idddd")
    this.setState({ POId: poId, PoLineItemId: poLineId })
    // console.log(this.state.PurchaseOrderLineId,this.state.PurchaseOrderId,"WWWW")
    this.POCommentPopUpModal()
  }
  uploadDocuments(){
    console.log("Pending")
  }

  render() {
    var roles = AuthHandlerInstance.getRoles()
    console.log(roles)
    var groups = AuthHandlerInstance.getGroups()
    let Id1 = this.state.POId
    let Id2 = this.state.PoLineItemId
    // console.log(Id1,Id2,"WWW")
    // console.log(this.state.POId,this.state.PoLineItemId,"WWW----")
    // console.log(this.props.allpodetailsuplier.allpodetails.recordset, "@@@@")

    return (

      <div className="Container-fluid pageheight"  >
        {/*----------Document comment-------------- */}
        {
          Id1 && Id2 ? (<POCommentPopUp action={this.state.POCommentPopUpModal} togglePOCommentPopUpModal={(e) => this.togglePOCommentPopUpModal(e)} POId={Id1} PoLineItemId={Id2} path='/ExpeditingApprovedPOAcceptance' />) : null
        }
        {/*----------Document Comment end  */}

        <div className="Container-fluid p-4" >

          {/* ---------Upload DeliverScheduleModal  By Supplier Start-------- */}
          <Modal isOpen={this.state.DeliverScheduleModal}>

            <ModalHeader HeaderStyle="modal-header ">
              <h4 style={{ color: 'black', textAlign: ' center', verticalAlign: 'middle' }}>Submit Delivery Schedule</h4>
              <button type="button" className="close" aria-label="Close" onClick={this.deliverschedulemodal} style={{ color: 'black' }}>
                <span aria-hidden="true">&times;</span>
              </button>
            </ModalHeader>


            <ModalBody Style="modal-body modalbodyssmall">
              <div className="row">
                <div className="col pt-2">
                  <div className="row">
                    <div className="col"><b>Delivery Schedule : </b></div>
                    <div className="col-sm-6">
                      <input type="file" className="form-control-file" name="" onChange={(e) => this.handleFileInput(e)} id="exampleFormControlFile2" />
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col pt-5">
                  <div className="row">
                    <div className="col pt-1"><b>Comments : </b></div>
                    <div className="col">
                      <input type="text" className="form-control" value={this.state.comments} onChange={this.comments} />
                    </div>
                  </div>
                </div>
              </div>
            </ModalBody>

            <ModalFooter FooterStyle="modal-footer">
              <div>
                <button className="btn2 btn-sms1 mt-2 ml-4 float-right" onClick={this.modalSubmit} type="submit">OK</button>
                <button className="btn2 btn-sms3 mt-2 ml-4 float-right" onClick={this.deliverschedulemodal} type="submit">Cancel</button>
              </div>

            </ModalFooter>
          </Modal>
          {/* --------Upload DeliverScheduleModal Bu Supplier  End-------------- */}

          {/* ---------Approve DeliverScheduleModal by Expeditor Start-------- */}
          <Modal isOpen={this.state.ApproveScheduleModal}>

            <ModalHeader HeaderStyle=" modal-header">
              <h4 style={{ color: 'black', textAlign: ' center', verticalAlign: 'middle' }}>Set Dates</h4>
              <button type="button" className="close" aria-label="Close" onClick={this.approveschedulemodal} style={{ color: 'black' }}>
                <span aria-hidden="true">&times;</span>
              </button>
            </ModalHeader>


            <ModalBody Style="modal-body modalbodyssmall">

              <div className="row mt-2">
                <div className="col pt-2 ">
                  <div className="row">
                    <div className="col-md-6"><b>Set Expected Delivery Date : </b></div>
                    <div className="col">

                      <input type='date' id="myDate" value={this.state.value} onChange={(e) => this.handleExpectedDeliveryDate(e)} />
                      {/* <button onClick={this.handleClick} className='btn-border'> <p id="demo"></p></button> */}

                    </div>
                  </div>
                </div>
              </div>

              <div className="row mt-2">
                <div className="col pt-2">
                  <div className="row">
                    <div className="col-md-6"><b>Set Document Submission Due Date : </b></div>
                    <div className="col">

                      <input type='date' id="myDate1" value={this.state.value} onChange={(e) => this.handleSubmissionDueDate(e)} />
                      {/* <button onClick={this.handleClick} className='btn-border'> <p id="demo1"></p></button> */}

                    </div>
                  </div>
                </div>
              </div>

            </ModalBody>
            <ModalFooter FooterStyle="modal-footer ">
              <div>

                <button className="btn2 btn-sms1 mt-2 ml-4 float-right" onClick={this.approvalmodalsubmit} type="submit">OK</button>

                <button className="btn2 btn-sms3 mt-2 ml-4 float-right" onClick={this.approveschedulemodal} type="submit">Cancel</button>

              </div>

            </ModalFooter>
          </Modal>
          {/* --------Approve DeliverScheduleModal by Expeditor  End-------------- */}

          {/* ---------Revise DeliverScheduleModal by Expeditor Start-------- */}
          {/* {this.state.array2.map((value, index) => ( */}
          <Modal isOpen={this.state.ReviseScheduleModal}>

            <ModalHeader HeaderStyle=" modal-header">
              <h4 style={{ color: 'black', textAlign: ' center', verticalAlign: 'middle' }}>Revise Delivery Schedule</h4>
              <button type="button" className="close" aria-label="Close" onClick={this.reviseschedulemodal} style={{ color: 'black' }}>
                <span aria-hidden="true">&times;</span>
              </button>
            </ModalHeader>


            <ModalBody Style="modal-body modalbodyextrasmall">
              <div className="row">
                <div className="col pt-2">
                  <div className="row">
                    <div className="col-md-6"><b>Comments : </b></div>
                    <div className="col">

                      <input type="text" className="form-control" value={this.state.commentsexpeditor} onChange={this.comments} />

                    </div>
                  </div>
                </div>
              </div>
            </ModalBody>
            <ModalFooter FooterStyle="modal-footer">
              <div>
                <button className="btn2 btn-sms1 mt-2 ml-4 float-right" onClick={this.revisemodalsubmit} type="submit">Request Revision</button>
                <button className="btn2 btn-sms3 mt-2 ml-4 float-right" onClick={this.reviseschedulemodal} type="submit">Cancel</button>
              </div>
            </ModalFooter>
          </Modal>
          {/* ))} */}
          {/* --------Revise DeliverScheduleModal by Expeditor  End-------------- */}
          {/* --------Success Failure Modal for upload delivery schedule for supplier Start-------------- */}
          <div>
            <SuccessFailureModal action={this.state.modal} toggleSuccessModal={(e) => this.toggleSuccessModal(e)}
              headertitle={this.state.headertitle} text={this.state.text} icon='check-circle' iconcolor="green" FooterButton="OK" path='/TestModal' />
          </div>
          {/* --------Success Failure Modal End-------------- */}

          <div className="row pr-4" >
            <div className="col-md-8  ">
              {roles[5] ? <>
                <Link to={{ pathname: '', state: {} }}>

                  <div><button className="btn2 btn-sms1 mt-2 float-right mr-4 " disabled={this.state.checked.length == 0 && this.state.checkedArray.length == 0 ? true : false} onClick={this.uploadDocuments()} >Upload Documents</button></div>
                </Link>
              </>
                :
                  <>
                  </>
              }
            </div>

            <div className="col pt-2  xs={last}">
              {/* <SearchBar placeholder="Search" label="Search" btnName="" /> */}
              <SearchBar placeholder="Search" value={this.state.searchTerm} searchInputHandler={(e) => { this.handleISearch(e) }} searchClick={this.handleSearching} label="Search" btnName="" />
            </div>
          </div>

          <div className="row-md-8 pr-4">
            <div className="col ">

              <div className="row  headerbar ">
                <div className="col-md-1 pt-2 pb-2 checkboxheaderbar borderheaderbar headeralign">
                  <input type="checkbox" onClick={this.handleChange} checked={this.state.selectAll} />
                </div>
                <div className="col-md-2 pt-2 pb-2 borderheaderbar headeralign">PO Number</div>
                <div className="col-md-2 pt-2 pb-2 borderheaderbar headeralign">PO Item</div>
                <div className="col-md-2 pt-2 pb-2 borderheaderbar d-none d-sm-block headeralign">PO Line Item Amount</div>
                <div className="col-md-3 pt-2 pb-2 borderheaderbar headeralign">Status </div>
                <div className="col-md-2 pt-2 pb-2 borderheaderbar d-none d-sm-block headeralign">Action </div>
              </div>




              {this.props.allpodetailsuplier.allpodetails && this.props.allpodetailsuplier.allpodetails.recordset && this.props.allpodetailsuplier.allpodetails.recordset.length > 0 && this.props.allpodetailsuplier.allpodetails.recordset.map((element, Index) =>
                <div className={Index % 2 == 0 ? 'row border ' : 'row  background '}
                  onClick={() => this.togglebutton(Index)} data-toggle="collapse" data-target={`.multi-collapse${Index}`}>
                  {/* {roles[5] ? <> */}
                  <div className="col-md-1 pt-2 pb-2 borderheaderbar headeralign">
                    {/* <input type="checkbox" checked={this.state.selected && this.state.selected.length >0 && this.state.selected[element.PurchaseOrderId] && this.state.selected[element.PurchaseOrderId] == true ? true:false} onChange={(event) => this.handleSingleCheckboxChange(element.PurchaseOrderId)} value=""/>   */}
                    <input type="checkbox" checked={this.state.checked.find((item) => item.po === element.PurchaseOrderId && item.polineid === element.PurchaseOrderLineId)} onChange={() => this.handleSingleCheckboxChange(Index)} value="" hidden={(roles[5] && (element.ExpeditingStatusId!=0 && element.ExpeditingStatusId!=3)) || (roles[12] && element.ExpeditingStatusId>1) || (roles[7] && element.ExpeditingStatusId!=2) ?true:false}
                    />
                    {/* <input key={element.id} type='checkbox'name={element.POSAPId} value={element.POSAPId} checked= {element.POSAPId == "Delivery Schedule Uploaded" ? this.state.checked[false] : this.state.checked[Index]}  disabled={element.status == "Delivery Schedule Uploaded" ? true : false  } onChange={() => this.handleSingleCheckboxChange(Index)} />         */}
                  </div>
                  <div className="col-md-2 pt-2 pb-2 borderheaderbar headeralign">{element.POSAPId}</div>
                  <div className="col-md-2 pt-2 pb-2 borderheaderbar headeralign ">{element.POLineItemSAPCode}</div>
                  <div className="col-md-2 pt-2 pb-2 borderheaderbar amount-text headeralign">{numberWithCommas(element.POLineItemAmount)}</div>
                  <div className="col-md-3 pt-2 pb-2 borderheaderbar headeralign">{element.ExpeditingStatusName ? element.ExpeditingStatusName : element.poStatus + " and Documents Upload Pending"}</div>
                  <div className="col-md-2 pt-2 pb-2 borderheaderbar text-center d-none d-sm-block headeralign">
                    <FontAwesomeIcon icon={"sms"} style={{ marginRight: "15px", cursor: "pointer" }} color={"block"} title="Comments" size="lg" onClick={() => this.rowClick(Index)} />
                    <Link to={{ pathname: '/ExpeditingPOAcceptanceTrail', state: { poId: element.PurchaseOrderId, lineItemID: element.PurchaseOrderLineId } }}><FontAwesomeIcon icon={"eye"} color="black" title="View" size="lg" /></Link>
                  </div>

                  <div style={{maxWidth:"1400px"}} className={Index == this.state.multiCollapseIndex ? ` pt-2 mb-2 detailpanebackground container collapse multi-collapse${Index}` : `container collapse`}>
                    <form>
                      <div></div>
                      <div className="row mt-2">
                        <div className="col-md-3">
                          <b>WBS No: </b>
                        </div>
                        <div className="col">
                          {element.WBSCode}
                        </div>

                        <div className="col-md-4">
                          <b>Location: </b>
                        </div>
                        <div className="col">
                          {element.Location}
                        </div>
                      </div>

                      <div className="row mt-2">
                        <div className="col-md-3">
                          <b>PO Created On: </b>
                        </div>
                        <div className="col">
                          {dateFormater(element.POCreationDate)}
                        </div>

                        <div className="col-md-4">
                          <b>PO Document: </b>
                        </div>
                        <div className="col">
                        <FontAwesomeIcon icon={"file-download"} color={"black"} title="download" size="2x" onClick={() => this.onclickDownload(element.DocumentId)} />
                        </div>
                        <div className="col-md-4">
                            <b>Delivery Schedule Document: </b>
                        </div>
                        <div className="col">
                          <FontAwesomeIcon icon={"file-download"} color={"black"} title="download" size="2x" onClick={() => this.onclickDownload(element.DeliveryScheduleDoc)} />
                        </div>
                        
                      </div>


                      {!roles[7] == true ?
                        <>
                          <div className="row mt-2">
                            <div className="col-md-3">
                              <b>PO Acceptance Document: </b>
                            </div>
                            <div className="col">
                              <FontAwesomeIcon icon={"file-download"} color={"black"} title="download" size="2x" onClick={() => this.onclickDownload(element.DocumentId)} />
                            </div>
                          </div>
                        </>
                        :

                        roles[7] == true ?

                          <>
                            <div className="row mt-2">
                              <div className="col-md-3">
                                <b>Expected Delivery Date: </b>
                              </div>
                              <div className="col">
                                {element.ExpectedDeliveryDate?dateFormater(element.ExpectedDeliveryDate):null}
                              </div>

                              <div className="col-md-4">
                                <b>Document Submission Due Date: </b>
                              </div>
                              <div className="col">
                                {element.DocumentSubmissionDueDate?dateFormater(element.DocumentSubmissionDueDate):null}
                              </div>
                            </div>
                            <div className="row mt-2">
                              <div className="col-md-3">
                                <b>PO Acceptance Document: </b>
                              </div>
                              <div className="col">
                                <FontAwesomeIcon icon={"file-download"} color={"black"} title="download" size="2x" onClick={() => this.onclickDownload(element.DocumentId)} />
                              </div>
                              <div className="col-md-4">
                                <b>Delivery Schedule Document: </b>
                              </div>
                              <div className="col">
                                <FontAwesomeIcon icon={"file-download"} color={"black"} title="download" size="2x" onClick={() => this.onclickDownload(element.DeliveryScheduleDoc)} />
                              </div>
                            </div>
                          </>
                          : null}
                      <br />
                    </form>
                  </div>
                </div>
              )}
              <br />
              <br />
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => ({ dsdetails: state.expeditingReducer, allpodetailsuplier: state.vendorReducer, file: state.file, })
export default connect(mapStateToProps, { GetAllPoAcceptanceDetailForSupplier, updateDeliveryScheduleDetails, uploadPaymentAcknowledgement, postDeliveryScheduleDetails, postCommentsForPOs })(ExpeditingApprovedDeliverySchedule);